import { useMemo } from "react";
import store from "store";

const usePreviousPathname = (defaultPath = "/") => {
  const previousPath = useMemo(() => {
    const storedPath = store.get("app.previousPathname");

    if (!storedPath) {
      return defaultPath;
    }

    // Exclude conversations
    if (storedPath.includes("/conversations")) {
      return defaultPath;
    }

    return storedPath;
  }, [defaultPath]);

  return previousPath;
};

export default usePreviousPathname;
